import React, { useEffect, useState } from "react";
import FuturesSections from "./FuturesSections";
import { useRouter } from "next/router";
import axiosInterceptorInstance from "@/elements/axiosInterceptorInstance";
import TopOptionsSection from "./TopOptionsSection";
import StockTopDetails from "@/components/StocksDetail/StockTopDetails";
import TopOptionsDesktopSection from "./TopOptionsDesktopSection";

const OPTIONS = [
    {
        key: "Volume",
        value: "volume"
    },
    {
        key: "OI",
        value: "oi"
    },
    {
        key: "Price",
        value: "price"
    }
];

export default function FNO({ data, stocksDetail, activeChartType, setActiveChartType, scriptData, isPaidUserPage }) {
    const [activeButton, setActiveButton] = useState("price"); //fnoId ?? expiryDateWithFinCodeList?.[0]?.finCode);
    const [loading, setLoading] = useState(true);
    const router = useRouter();
    const [fnoData, setFnoData] = useState({});

    const [datas, setDatas] = useState({});

    useEffect(() => {
        const scriptDetails = scriptData?.[activeChartType === 1 ? "NSE" : "BSE"] ?? {};
        OPTIONS.forEach((v) => {
            axiosInterceptorInstance
                .get(
                    `/resources/stock-details/fno-data?sortCriteria=${v.value}&scripCode=${scriptDetails?.scriptCode}&segment=${scriptDetails?.segment}`
                )
                .then((res) => {
                    setDatas(res.data);
                    setFnoData((pre) => ({ ...pre, [v.value]: res.data }));
                })
                .finally(() => setTimeout(() => setLoading(false), 300));
        });
    }, [activeButton, scriptData]);

    return (
        <div className="font-Inter">
            {loading ? (
                <>
                    <div className="flex justify-between m-4 h-12 animate-pulse bg-[#f2f2f2] rounded-md" />
                    <div className="flex justify-between m-4 h-60 animate-pulse bg-[#f2f2f2] rounded-md" />
                    <div className="flex justify-between m-4 h-20 animate-pulse bg-[#f2f2f2] rounded-md" />
                    <div className="flex justify-between m-4 h-40 animate-pulse bg-[#f2f2f2] rounded-md" />
                </>
            ) : (
                <>
                    <StockTopDetails
                        isPaidUserPage={isPaidUserPage}
                        preData={data}
                        finCode={stocksDetail?.finCode}
                        activeChartType={activeChartType}
                        setActiveChartType={setActiveChartType}
                    />
                    <div className="block md:hidden">
                        <TopOptionsSection
                            OPTIONS={OPTIONS}
                            data={fnoData[activeButton] ?? {}}
                            activeChartType={activeChartType}
                            activeButton={activeButton}
                            setActiveButton={setActiveButton}
                            finCode={stocksDetail?.finCode}
                        />
                    </div>
                    <div className="hidden md:block">
                        <TopOptionsDesktopSection
                            OPTIONS={OPTIONS}
                            fnoData={fnoData}
                            activeChartType={activeChartType}
                            activeButton={activeButton}
                            setActiveButton={setActiveButton}
                            finCode={stocksDetail?.finCode}
                        />
                    </div>
                    <FuturesSections
                        futures={datas?.futures}
                        activeChartType={activeChartType}
                        finCode={stocksDetail?.finCode}
                        scriptData={scriptData}
                    />
                </>
            )}
        </div>
    );
}
